import { render, staticRenderFns } from "./ProList.vue?vue&type=template&id=18b95504&scoped=true&"
import script from "./ProList.vue?vue&type=script&lang=js&"
export * from "./ProList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b95504",
  null
  
)

export default component.exports